import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../constants';
import { AppWrap } from '../../wrapper';

import './Header.scss';

const scaleVariants ={
  whileInView: {
    scale : [0, 1],
    opacity: [0,1],
    transition: {
      duration: 1,
      ease: 'easeInOut'
    }
  }
}

const Header = () => {
  return (
    <div id='home' className='app__header app__flex'>
      <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1]}}
      transition={{ duration: 0.5 }}
      className="app__header-info"
      >
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <span>💫</span>
            <div style={{ lineHeight: 1.3, marginLeft: 20 }}>
              <p className='p-head'>Hello, I am </p>
              <h1 className='head-text'><span>Samuel</span></h1>
            </div>
          </div>
          
          <div className='tag-cmp app__flex'>
           <p className='p-head'>Welcome to my <em>web development</em> portfolio!</p>
          </div>
        </div>  
        <motion.div
          variants={ scaleVariants }
          whileInView={ scaleVariants.whileInView }
          className='app__header-circles'
        >
          {[images.mongodb, images.express, images.react, images.node].map((circle, index) => (
            <div className='circle-cmp app__flex' key={`circle-${index}`}>
              <img src={ circle } alt="circle" />
            </div>
          ))}
        </motion.div>     
      </motion.div>
      
     
    </div>
  );
}

export default AppWrap( Header, 'home');